<!--
 * @Author:
 * @LastEditTime: 2022-04-28 16:33:00
 * @Description:
-->
<template>
  <el-card class="h-full">
    <div class="flex mb-20px">
      <el-button size="small" type="primary" @click="createApi()">新增</el-button>
    </div>
    <el-table
      stripe
      ref="eltable"
      :height="tableHeight"
      border
      :data="tableData"
      @sort-change="sortChangeTable"
    >
      <el-table-column label="名称" prop="name" sortable></el-table-column>
      <el-table-column label="显示名称" prop="displayName" sortable></el-table-column>
      <el-table-column label="必须" prop="name" sortable></el-table-column>
      <el-table-column label="在发现文档中显示" prop="showInDiscoveryDocument" sortable>
        <template slot-scope="scope">
          {{ scope.row.showInDiscoveryDocument ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="启用" prop="enabled" sortable>
        <template slot-scope="scope">
          {{ scope.row.enabled ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column width="140" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button @click="editApi(scope.row)" size="mini">修改</el-button>
          <el-button size="mini" @click="deleteApi(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <operate-api-dialog
      v-if="showOperateApiDialog"
      :operateApiProps="operateApiProps"
      :apiForm="apiForm"
      @refreshList="findList"
    ></operate-api-dialog>
  </el-card>
</template>

<script>
import { ApiResourceApi } from '@wiz-api/auth-server'

const resourceApi = new ApiResourceApi()

const OperateApiDialog = () => {
  return import('../components/apiResource/OperateApiDialog')
}
export default {
  name: 'client',
  components: {
    OperateApiDialog,
  },
  data() {
    return {
      showOperateApiDialog: false,
      operateApiProps: {
        title: '新增api资源',
        editType: 'create',
        visible: true,
      },
      apiForm: {
        name: '',
        displayName: '',
        userClaims: [
          'email',
          'email_verified',
          'name',
          'phone_number',
          'phone_number_verified',
          'role',
        ],
        description: '',
        enabled: true,
        showInDiscoveryDocument: true,
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      sort: {
        type: '',
        sortName: 'creationTime',
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      const [err, res] = await resourceApi.getList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
    },
    createApi() {
      this.showOperateApiDialog = true
      this.operateApiProps = this.$options.data().operateApiProps
      this.apiForm = this.$options.data().apiForm
    },
    async editApi(row) {
      const [err, res] = await resourceApi.get(row.id)
      if (!err) {
        this.apiForm = res
      }
      this.showOperateApiDialog = true
      this.operateApiProps = this.$options.data().operateApiProps
      this.operateApiProps.editType = 'edit'
      this.operateApiProps.title = '编辑api资源'
    },
    /**
     * @description: 删除api
     * @param {*}
     * @return {*}
     */
    deleteApi(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await resourceApi.callDelete(id)

          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            this.searchList()
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
  created() {
    this.searchList()
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.eltable.doLayout()
    })
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
